import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import App from './App'
import * as serviceWorker from './serviceWorker'

import { icons } from './assets/icons'
import { RecoilRoot } from 'recoil'
import { Provider } from 'react-redux'
import store from './store'

const queryClient = new QueryClient()
React.icons = icons

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
      <Provider store={store}>
        <App />
      </Provider>
    </RecoilRoot>
  </QueryClientProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
